// export const BASE_URL = 'http://127.0.0.1:8000/';
// export const BASE_MEDIA = 'http://127.0.0.1:8000';
export const BASE_MEDIA = 'https://cnzecke.pythonanywhere.com';
export const BASE_URL = 'https://cnzecke.pythonanywhere.com/';

export const API_ROUTES = {
  SIGNIN: `${BASE_URL}api/auth/`,
  VERIFY: `${BASE_URL}api/verify/`,
  UTILISATEUR: {
    BASE: `${BASE_URL}api/utilisateur/`,
    CHECKSIGN: (userId: string) => `${BASE_URL}api/check-signature/${userId}/`,
    BONDS: (userId: string) => `${BASE_URL}api/bond-detenteur/${userId}`,
    PROFIL: (connectedUserId: string) =>
      `${BASE_URL}api/utilisateur-profils/?connectedUser=${connectedUserId}`,
    DETAILS: (connectedUserId: string) =>
      `${BASE_URL}api/utilisateur-details/?connectedUser=${connectedUserId}`,
    ADMIN_CUSTOM: (userId: string) =>
      `${BASE_URL}api/get-admin-utilisateurs/?user=${userId}`, // get users wrt to profile & asset manager
    LISTE_AGENCE: (userId: string) =>
      `${BASE_URL}api/utilisateur-agence/${userId}`,
  },
  ASSETMANAGER: {
    BASE: `${BASE_URL}api/asset-manager/`,
    ADD: (userId: string) => `${BASE_URL}api/asset-manager/${userId}/`,
    UPDATE: (assetId: string) => `${BASE_URL}api/asset-manager/${assetId}/`,
    DELETE: (assetId: string) => `${BASE_URL}api/asset-manager/${assetId}/`,
  },

  PACK: {
    BASE: `${BASE_URL}api/pack/`,
    ADD: (userId: string) => `${BASE_URL}api/pack/${userId}/`,
    UPDATE: (packId: string) => `${BASE_URL}api/pack/${packId}/`,
    DELETE: (packId: string) => `${BASE_URL}api/pack/${packId}/`,
  },

  PARAMETER: {
    BASE: `${BASE_URL}api/parameter/`,
    GET: (paramId: string) => `${BASE_URL}api/parameter/${paramId}`,
    UPDATE: (paramId: string) => `${BASE_URL}api/parameter/${paramId}/`,
  },

  ABONNEMENT: {
    BASE: `${BASE_URL}api/abonnement/`,
    ADD: (userId: string) => `${BASE_URL}api/addabonnement/${userId}/`,
    LIST: (userId: string, assetId: string) =>
      `${BASE_URL}api/listabonnement/${userId}/${assetId}/`,
  },

  TCHAT: {
    BASE: (userId: string) => `${BASE_URL}api/conversations/${userId}`,
    SEARCH: (keyword: string) => `${BASE_URL}api/search-users/?q=${keyword}`,
    MESSAGE: `${BASE_URL}api/message/`,
    FIND: (userId: string, userId2: string) =>
      `${BASE_URL}api/find-conversation/?user1=${userId}&user2=${userId2}`,
  },
  PAY: {
    BASE: (userId: string) => `${BASE_URL}api/create-payment/${userId}`,
  },
  KYC: {
    USER: (userId: string) => `${BASE_URL}api/kyc/me/${userId}`,
    DETENTEUR: (userId: string) => `${BASE_URL}api/kyc/detenteur/${userId}`,
    BASE: () => `${BASE_URL}api/kyc/`,
  },
  AML: {
    USER: (userId: string) => `${BASE_URL}api/aml/me/${userId}`,
    DETENTEUR: (userId: string) => `${BASE_URL}api/aml/detenteur/${userId}`,
    BASE: () => `${BASE_URL}api/aml/`,
  },
  BOND: {
    BASE: `${BASE_URL}api/bond/`,
    AVAILABLE: (userId: string) =>
      `${BASE_URL}api/available-bonds/?user=${userId}`,
    OPTIONS: `${BASE_URL}api/bond-options/`,
    MARKET: (bondId: string) => `${BASE_URL}api/bond-market/${bondId}`,
    BIDASK: (bondId: string) => `${BASE_URL}api/bid-ask/${bondId}`,
    ACHAT: `${BASE_URL}api/bond-achat/`,
    VENTE: `${BASE_URL}api/bond-vente/`,
    TOTAL_TRANSACT: `${BASE_URL}api/total-bond-transact/`,
    MOVERS: `${BASE_URL}api/bond-movers/`,
  },
  FORUM: {
    BASE: `${BASE_URL}api/forum/`,
    ADDFORUM: (userId: string) => `${BASE_URL}api/forum/add-topic/${userId}/`,
    ADDPOST: (userId: string) => `${BASE_URL}api/forum/add-post/${userId}/`,
    ADDCOMMENT: (userId: string) =>
      `${BASE_URL}api/forum/add-comment/${userId}/`,
    CATEGORY: (topicId: string) => `${BASE_URL}api/forum/posts/${topicId}/`,
    POST: (postId: string) => `${BASE_URL}api/forum/post/${postId}/`,
    COMMENTS: (postId: string) => `${BASE_URL}api/forum/comments/${postId}/`,
  },
  ADMIN: {
    BASE: `${BASE_URL}api/admin`,
    REPORTING: `${BASE_URL}api/reporting`,
    REPORTINGBOND: `${BASE_URL}api/reporting-bond`,
    REPORTINSADMIN: `${BASE_URL}api/sadmin/reporting`,
    ADDBANK: (userId: string) => `${BASE_URL}api/admin/add-partner/${userId}/`,
    ADDAGENCY: (userId: string) => `${BASE_URL}api/admin/add-agency/${userId}/`,
    ADDUSER: (userId: string) => `${BASE_URL}api/admin/add-user/${userId}/`,
    BANK: (partnerId: string) => `${BASE_URL}api/admin/partner/${partnerId}/`,
    AGENCY: (agencyId: string) => `${BASE_URL}api/admin/agency/${agencyId}/`,
    ROLES: (userId: string) => `${BASE_URL}api/get-roles/${userId}/`,
    GETUSER: (userId: string) => `${BASE_URL}api/get-user/${userId}/`,
    GETRepporting: `${BASE_URL}api/admin/repporting`,
    SETROLES: (userId: string) => `${BASE_URL}api/update-role/${userId}/`,
  },
  GESTION: {
    PARTENAIRE: {
      BASE: `${BASE_URL}api/partenaire/`,
      ADMIN_CUSTOM: (userId: string) =>
        `${BASE_URL}api/get-admin-partenaires/?user=${userId}`, // get partenaires wrt to profile & asset manager
    },
    AGENCE: {
      BASE: `${BASE_URL}api/agence/`,
      ADMIN_CUSTOM: (userId: string) =>
        `${BASE_URL}api/get-admin-agences/?user=${userId}`, // get agences wrt to profile & asset manager
    },
    PROFIL: {
      BASE: `${BASE_URL}api/profil/`,
      USER_PROFIL: `${BASE_URL}api/utilisateur-profil/`,
      DELETE_PROFIL: `${BASE_URL}api/delete-profil/`,
    },
    GESTION_TITRE: {
      GET_TITRE: (userId: string) =>
        `${BASE_URL}api/get-titres/?user=${userId}`,
      EMISSION: `${BASE_URL}api/emission-titre/`,
      LIVRAISON: `${BASE_URL}api/livraison-titre/`,
      OPERATION_TITRE: `${BASE_URL}api/operation-titre/`,
      JUSTIFICATIF: `${BASE_URL}api/files/`,
    },
    COMPTA: {
      COMPTE: (userId: string) => `${BASE_URL}api/compte/?user=${userId}`,
      GL: (userId: string) => `${BASE_URL}api/grand-livre/?user=${userId}`,
      BALANCE: (userId: string) =>
        `${BASE_URL}api/balance-generale/?user=${userId}`,
    },
    REPORTING: {
      OPERATION: (userId: string) =>
        `${BASE_URL}api/reporting-operation/?user=${userId}`,
    },
  },
  PORTEFEUILLE: {
    USER_PORT: (userId: string) =>
      `${BASE_URL}api/utilisateur-content-portefeuille/${userId}`,
    KPI: (userId: string) =>
      `${BASE_URL}api/utilisateur-portefeuille-kpi/${userId}`,
  },
  DETENTEUR: {
    BASE: `${BASE_URL}api/detenteur/`,
    BOND: `${BASE_URL}api/detenteur-bond/`,
    GET_CLIENTS: (userId: string) =>
      `${BASE_URL}api/get-clients/?user=${userId}`,
  },
  OPERATION: {
    OPERATION: `${BASE_URL}api/operation/`,
    ORDERS: (userId: string) => `${BASE_URL}api/utilisateur-orders/${userId}`,
    TRANSACTIONS: (userId: string) =>
      `${BASE_URL}api/utilisateur-transactions/${userId}`,
    FINALIZE_TRANSACTION: (transactionId: string) =>
      `${BASE_URL}api/finalize-transaction/${transactionId}/`,
    VENTES: (userId: string) => `${BASE_URL}api/utilisateur-ventes/${userId}`,
    UPDATE: (userId: string, opeId: string) =>
      `${BASE_URL}api/operation-update/${userId}/${opeId}/`,
    DELETE: (userId: string, opeId: string) =>
      `${BASE_URL}api/operation-delete/${userId}/${opeId}/`,
  },
  FAVORIS: {
    BASE: `${BASE_URL}api/favoris/`,
    USER: (userId: string) => `${BASE_URL}api/utilisateur-favoris/${userId}`,
  },
};
